// Module
var code = "<div layout=\"column\" class=\"full-height\"> <div flex layout=\"column\" layout-align=\"center center\" class=\"fade-element-in-only\"> <empty-state src=\"assets/images/empty_state/empty_state_customer_options.png\" text=\"Coming Soon...\"> </empty-state> </div> </div> ";
// Exports
export default code;